import { Close as CloseIcon } from '@mui/icons-material';
import {
  Icon,
  IconButton,
  Snackbar,
  SnackbarContent,
  styled,
} from '@mui/material';
import { removeError } from '@pingum/app-state-management/error/actions';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

const StyledSnackbarContent = styled(SnackbarContent)(({ theme }) => {
  const { palette } = theme.vars || theme;
  const spacing = theme.spacing
    ? theme.spacing(1)
    : 8;
  return {
    backgroundColor: palette.error?.dark || palette.error?.main,
    '& .error-container__message': {
      display: 'flex',
      alignItems: 'center',
    },
    '& .error-container__icon': {
      fontSize: 20,
      opacity: 0.9,
      marginRight: spacing,
    },
    '& .error-container__close': { padding: 4 },
  };
});

export const ErrorContainerComponent = (props) => (
  <div>
    {
      props.errors.map((error) => {
        const close = () => {
          props.removeError(error.id);
        };
        setTimeout(close, props.errorTimeout);
        return (
          <Snackbar
            key={error.id}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
            open
            onClose={close}
          >
            <StyledSnackbarContent
              aria-describedby="message-id"
              message={(
                <span id="message-id" className="error-container__message">
                  <Icon className="error-container__icon"> error </Icon>
                  {error.message}
                </span>
              )}
              action={[
                <IconButton
                  key="close"
                  aria-label="Close"
                  color="inherit"
                  className="error-container__close"
                  onClick={close}
                >
                  <CloseIcon />
                </IconButton>,
              ]}
            />
          </Snackbar>
        );
      })
    }
  </div>
);

ErrorContainerComponent.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    message: PropTypes.string,
    dismissable: PropTypes.bool,
  })),
  errorTimeout: PropTypes.number,
  removeError: PropTypes.func,
};

ErrorContainerComponent.defaultProps = {
  errors: [],
  errorTimeout: 8000,
  removeError: () => { },
};

export const mapStateToProps = (state) => ({ errors: state.error.errorMessages });

export const mapDispatchToProps = (dispatch) => ({ removeError: (id) => dispatch(removeError(id)) });

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ErrorContainerComponent);
